"use client";

import dynamic from "next/dynamic";

export const MapDisplay = dynamic(() =>
  import("./MapDisplayComponent").then((mod) => mod.MapDisplay),
);
